import React, { useEffect } from "react";

import { Toast, ToastContainer } from "react-bootstrap";

import classNames from "classnames";

import styles from "./ToastMessage.module.scss";

export type ToastMessageType = "error" | "success" | "info";

interface ToastMessageProps {
  message: string;
  show: boolean;
  setShow: (show: boolean) => void;
  autohide?: boolean;
  delay?: number;
  position?: "top-start" | "top-end" | "bottom-start" | "bottom-end";
  type?: ToastMessageType;
}

export const ToastMessage: React.FC<ToastMessageProps> = ({
  message,
  show,
  setShow,
  autohide = true,
  delay = 10000,
  position = "top-end",
  type = "info",
}) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => setShow(false), delay);
      return () => clearTimeout(timer);
    }
  }, [show, delay, setShow]);

  return (
    <ToastContainer position={position} className={classNames("p-3", styles["toast-container-fixed"])}>
      <Toast
        show={show}
        onClose={() => setShow(false)}
        autohide={autohide}
        delay={delay}
        className={classNames(
          {
            [styles["error-toast"]]: type === "error",
            [styles["success-toast"]]: type === "success",
            [styles["info-toast"]]: type === "info",
          },
          styles["toast-body"],
        )}
      >
        <Toast.Body className={classNames(styles["toast-body"], "b3")}>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};
